// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const modernIssueCreateInGenericFunctions = (params: any) => {
	const fields = params?.fields;
	const title = params?.title;
	const callback = params?.callback;

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	document.dispatchEvent(
		new CustomEvent('openIssueCreateDialog', {
			detail: {
				payload: {
					triggerPointKeySuffix: 'generic',
					isPrefillingAllowed: true,
					callback,
					title,
					prefilledFields: fields
						? { pid: fields?.pid, issuetype: fields?.issueType, ...fields?.fields }
						: {},
				},
			},
		}),
	);
};
